import React from "react";
import YurtSVG from "./YurtSVG";
import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  a {
    text-decoration: none;
    font-weight: 700;
  }
  margin-bottom: 20px;
`;

const Logo = styled.div`
  width: 2rem;
  height: 2rem;
  svg {
    fill: lightgrey;
  }
`;

const Nav = styled.div`
  display: flex;
`;

const Item = styled.div`
  margin-left: 80px;

  a {
    text-transform: lowercase;
    color: ${({ path }) => (path ? "black" : "var(--grey)")};
  }
`;

function Header() {
  const { pathname } = useLocation();

  return (
    <Container>
      <Logo>
        <YurtSVG />
      </Logo>
      <Nav>
        <Item path={pathname === "/contacts" || pathname === "/"}>
          <NavLink to="/contacts">Contacts</NavLink>
        </Item>
        <Item path={pathname === "/build"}>
          <NavLink to="/build">Build</NavLink>
        </Item>
        <Item path={pathname === "/pricing"}>
          <NavLink to="/pricing">Pricing</NavLink>
        </Item>
      </Nav>
    </Container>
  );
}

export default Header;
